<template>
  <form @submit.prevent="$emit('submit')" class="white-box p30">
    <div class="row">
      <div class="col-sm-6">
        <FieldTextInput name="No. CRM" rules="required" v-model="value.no_crm" :disabled="true" />
      </div>
      <div class="col-sm-12">
        <div class="separator dashed"></div>
      </div>
      <div class="col-sm-12">
        <FieldTextArea name="Settlement" rules="required" v-model="value.settlement" :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <FieldSelect name="Status" rules="required" v-model="value.status" :options="options.SETTLEMENT_PROCESS"
          :disabled="disabled" />
      </div>
    </div>
    <div v-if="!disabled" class="d-flex justify-content-center">
      <button class="btn btn-orange" type="submit">Save</button>
    </div>
  </form>
</template>
<script>
import FieldTextInput from '@/components/field/TextInput.vue';
import FieldTextArea from '@/components/field/TextArea.vue';
import FieldSelect from '@/components/field/Select.vue';
import { SETTLEMENT_PROCESS } from './constant.js'

export default {
  name: "FormFeedbackSettlementForm",
  components: {
    FieldTextArea,
    FieldTextInput,
    FieldSelect
  },
  props: ['value', 'disabled'],
  data() {
    return {
      options: {
        SETTLEMENT_PROCESS
      }
    }
  }
}
</script>
